import { QUESTION_TYPE } from '../../../../constants/questionTypes';
import type { TextInputQuestion } from '../../../../types/index';
import type { ApiQuestion } from '../../../../internalTypes';
import type { ResolvedQuestionShell } from '../shared/resolveQuestionShell';

export function mapTextInputQuestion(
  raw: ApiQuestion,
  shell: ResolvedQuestionShell,
  configs: { key: string; value?: string[]; childConfigs?: { key: string; value?: string[] }[] }[],
  language?: string
): TextInputQuestion {
  const contentTypeConfig = configs.find(c => c.key === 'CONTENT_TYPE');
  const maxCharConfig = contentTypeConfig?.childConfigs?.find(
    cc => cc.key === 'MAX_CHARACTER_COUNT'
  );
  const maxCharacterCount = maxCharConfig?.value?.[0] ? Number(maxCharConfig.value[0]) : undefined;

  const contentType = contentTypeConfig?.value?.[0]?.toUpperCase() ?? 'LONG';
  const inputVariant: 'short' | 'long' = contentType.includes('SHORT') ? 'short' : 'long';

  const textDetail = raw.answerDetails?.[0];
  const placeholder = textDetail
    ? (language && textDetail.translations?.[language]?.answerText) || textDetail.answerText
    : undefined;

  return {
    ...shell,
    type: QUESTION_TYPE.TEXTFIELD,
    inputVariant,
    ...(maxCharacterCount !== undefined ? { maxCharacterCount } : {}),
    ...(placeholder ? { placeholder } : {}),
  };
}
